import { render, staticRenderFns } from "./standart.vue?vue&type=template&id=ea3bb312&scoped=true&"
import script from "./standart.vue?vue&type=script&lang=js&"
export * from "./standart.vue?vue&type=script&lang=js&"
import style0 from "./standart.vue?vue&type=style&index=0&id=ea3bb312&scoped=true&lang=css&"
import style1 from "./standart.vue?vue&type=style&index=1&id=ea3bb312&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea3bb312",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ea3bb312')) {
      api.createRecord('ea3bb312', component.options)
    } else {
      api.reload('ea3bb312', component.options)
    }
    module.hot.accept("./standart.vue?vue&type=template&id=ea3bb312&scoped=true&", function () {
      api.rerender('ea3bb312', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/memorandum/create/mem_preview/addon/standart.vue"
export default component.exports